const angular = require('angular');
var app = angular.module('learn-controllers');

/**
 * Edit groups Controller
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.controller('editGroup', ['Application', 'Authorization', 'Groups', 'AccessHelper', '$scope', '$translate', function (Application, Authorization, Groups, AccessHelper, $scope, $translate) {
  var self = this;

  self.features = Application.features.flags();
  self.authtoken = Authorization.getAuthToken();
  self.user = self.authtoken.user;

  var routeParameters = Application.navigation.getRouteParameters();

  self.allowance = {
    settings: AccessHelper.isAllowed(['admin', 'settings'], null, ['admin']),
  };

  if (!self.allowance.settings) {
    Application.navigation.goTo('/explore');
    return;
  }

  self.info = {
    newGroup: routeParameters.id === 'new' || !routeParameters.id,
    loading: false,
    editSaved: true,
    standardGroup: function() {
      return {
        user: self.user._id,
        name: '',
        description: '',
        departments: [],
        locations: [],
        teams: [],
        org_levels: [],
        grades: []
      };
    },
    goBack: function() {
      Application.navigation.goTo('/overview/settings/groups');
    },
    froalaOptions: {
      key: '4NC5fF6A3D4H3H3C4B-16UJHAEFZMUJOYGYQEa2d2ZJd1RAeF3C8B5C4E3C3B2G3A14A7==',
      charCounterCount: false,
      toolbarSticky: false,
      attribution: false,
      height: 600,
      imageDefaultWidth: 600,
      toolbarButtons: ['bold', 'italic', 'underline', 'strikeThrough', 'fontSize', 'color', 'emoticons', 'paragraphStyle', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'insertLink', 'undo', 'redo', 'customClear'],
      linkInsertButtons: ['linkBack'],
      charCounterMax: 500,
      quickInsertButtons: ['table', 'ul', 'ol', 'hr','embedly']
    }
  };

  self.update = function() {
    self.info.loading = true;
    Groups.update({subresource: self.group._id || routeParameters.id}, self.group).$promise
    .then(function(group) {
      self.group = group;
      self.info.editSaved = true;
      self.info.loading = false;
      Application.messaging.addMessage({type: 'success', duration: 5, text: 'Save successfull!'});
    }).catch(function(error) {
      Application.messaging.addMessage({type: 'error', duration: 6, text: 'An error occurred while attempting to save.'});
      console.log('error: ', error)
      self.info.loading = false;
    })
  };

  self.create = function() {
    self.info.loading = true;
    Groups.create({}, self.group).$promise
    .then(function(group) {
      self.group = group;
      self.info.newGroup = false;
      self.info.editSaved = true;
      self.info.loading = false;
      Application.messaging.addMessage({type: 'success', duration: 5, text: 'The group was created!'});
      Application.navigation.goTo('/overview/settings/groups')
    }).catch(function(error) {
      Application.messaging.addMessage({type: 'error', duration: 6, text: 'An error occurred while attempting to create.'});
      console.log('error: ', error)
      self.info.loading = false;
    })
  };

  self.initialize = function() {
    if (self.info.newGroup) {
      self.group = self.info.standardGroup();
      return;
    }

    self.info.loading = true;
    Groups.get({subresource: routeParameters.id, fields: 'company,user,name,external_id,description,departments,locations,teams,org_levels,grades'}).$promise
    .then(function(group) {
      self.group = group;
      self.info.loading = false;
    }).catch(function(error) {
      Application.messaging.addMessage({type: 'error', duration: 6, text: 'This group does not exist.'});
      console.log('error: ', error)
      self.info.loading = false;
      Application.navigation.goTo('/overview/settings');
    });

  };


  $translate([
    'edit.general.notification_fieldsMissing'
  ]).then(function(translations){
    self.translations = translations;
    self.initialize();
  });
}]);
